module.exports = {

    props: {
        employer: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            form: new Form({
                signature: '',
                options: [
                    {key: 'oversight_procedures', name: 'Oversight Procedures', value: false},
                    {key: 'complaint_procedures', name: 'Complaint Procedures', value: false},
                    {key: 'recertification_and_renewal', name: 'Recertification and Renewal', value: false},
                    {key: 'testing_procedures', name: 'Testing Procedures', value: false}
                ],
            }).dontClear(),
        }
    },

    methods: {
        save() {
            this.form.post(`/applications/acceptance-test-employer/${this.employer.id}/agreement`).then(response => {
                Alert.withAction('Thank you for signing the contract!<br>Your application will be approved, check your email for more information.').then(() => {
                    this.redirectTo('/')
                });
            }).catch(errors => {
                Alert.error(errors.first());
            })
        }
    },

    computed: {
        canSave() {
            for (var key in this.form.options) {
                if (!this.form.options[key].value) return false;
            }
            if(this.form.signature == '') return false;
            return true;
        }
    }
}